export default class {
    constructor(height) {
        this.height = height || 950;
        this.$content = $('.js-read-more-content');
        this.$button = $('.js-read-more-button');
        this.initialized = false;
    };

    init() {
        let that = this;

        if (!this.initialized) {
            if (this.$content.length && this.$button.length) {
                this.checkDescriptionHeight(this.$content, this.$content.height(), this.height, this.$button);

                // On page load, the fonts aren't loaded, causing the wrong size until a few cycles later.
                // This listens to the element's resizing event and runs the appropriate code on resize.
                this.$content[0].addEventListener('onresize', this.onResizeHandler);

                this.$button.click(function() {
                    if ($(this).hasClass('opened')) {
                        //closing
                        that.$content.css('max-height', that.height);
                        $(this).removeClass('opened').removeClass('button--arrow-up').addClass('button--arrow-down').html('View More');

                        // scroll back up to element if it would be off screen after collapse
                        if ($(this).offset().top < window.scrollY + that.getNavHeight()) {
                            that.jumpToElement('.js-read-more-content');
                        }
                    } else {
                        //opening
                        that.$content.css('max-height', 'none');
                        $(this).addClass('opened').removeClass('button--arrow-down').addClass('button--arrow-up').html('View Less');
                    }
                });
            }
            this.initialized = true;
        }
    }

    reset() {
        this.$content.css('max-height', 'none');
        this.$button.addClass('opened').removeClass('button--arrow-down').addClass('button--arrow-up').html('View Less');
    }

    /**
     * checkDescriptionHeight If the description is tall enough, trigger a read more button and shorten it
     * @param descElement
     * @param descHeight
     * @param maxHeight
     * @param readMoreButton
     */
    checkDescriptionHeight(descElement, descHeight, maxHeight, readMoreButton) {
        // Always get full content height
        descElement.css('max-height', 'none');
        descHeight = descElement.height();

        // If content was collapsed, collapse it
        if (!readMoreButton.hasClass('opened') && !readMoreButton.hasClass('hide')) {
            descElement.css('max-height', maxHeight);
        }

        if (descHeight > maxHeight + parseInt(readMoreButton.height())) {
            if (!readMoreButton.hasClass('opened')) {
                descElement.css('max-height', maxHeight);
            }
            readMoreButton.removeClass('hide');
        } else {
            readMoreButton.addClass('hide');
            descElement.css('max-height', 'none');
        }

        if (descElement.length) {
            descElement[0].removeEventListener('onresize', this.onResizeHandler);
        }
    };

    onResizeHandler() {
        this.checkDescriptionHeight(this.$content, this.$content.height(), this.height, this.$button);
    };

    // Scroll to element with provided id, this attempts to account for the sticky header
    jumpToElement(selector) {
        let top = $(selector).offset().top; //Getting Y of target element
        let offsetTop = this.getNavHeight();
        window.scrollTo(0, (top - offsetTop));
    }

    getNavHeight() {
        return document.querySelector('.nav').offsetHeight;
    }
}

